<div class="mt-5">
  <p class="text-medium mb-4">{{ 'FILE_UPLOAD.UPLOAD_OPTIONAL' | translate }}</p>
  <p class="font-normal text-base leading-6 mb-4 text-(--text-secondary)">
    {{ 'FILE_UPLOAD.ATTACH_DESCRIPTION' | translate }}
  </p>

  <!-- Show uploaded files -->
  <ng-container *ngIf="selectedFiles.length > 0">
    <div *ngFor="let file of selectedFiles; let i = index" class="flex items-center justify-between bg-white shadow-(--shadow-input) p-5 rounded-2xl mb-6">
      <div class="flex items-center gap-3">
        <img src="assets/icons/file-uploaded.svg" alt="file-icon" class="w-5 h-5" />
        <p class="text-medium break-all">{{ file.name }}</p>
      </div>
      <button (click)="removeFile(i)" class="cursor-pointer hover:opacity-80" type="button">
        <img src="assets/icons/bin.svg" alt="Delete icon" class="w-5 h-5" />
      </button>
    </div>
  </ng-container>

  <!-- Upload new files -->
  <div class="relative bg-white p-5 rounded-2xl shadow-(--shadow-input) text-center">
    <input
      #fileInput
      type="file"
      accept=".jpg,.png,.pdf,.doc"
      multiple
      (change)="onFileSelected($event)"
      class="absolute top-0 bottom-0 right-0 left-0 opacity-0"
    />
    <img src="assets/icons/file-upload.svg" alt="upload" class="mx-auto mb-3 w-6 h-6" />
    <p class="text-base font-medium text-(--text-primary) leading-6 mb-2">
      {{ 'FILE_UPLOAD.DRAG_DROP' | translate }}
    </p>
    <p class="text-sm text-(--text-muted) leading-5 font-normal">
      {{ 'FILE_UPLOAD.ACCEPTED_FORMATS' | translate }}
    </p>
    <button
      type="button"
      class="relative z-3 click-text my-5 text-(--brand-primary) font-medium cursor-pointer"
      (click)="fileInput.click()"
    >
      {{ 'FILE_UPLOAD.SELECT_FILE' | translate }}
    </button>
  </div>
</div>
